module.exports = __webpack_public_path__ + "static/img/Improving.c41f1be9.png";